module.exports = __webpack_public_path__ + "static/media/icon-posts-aggregated.4396c5a5.svg";